var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-flex -alignCenter t-caption1 t-fontWeightMedium",class:{
    'u-colorDarkMediumEmphasis': !_vm.liked,
    'u-colorLove': _vm.liked,
  },attrs:{"tabindex":"0","data-cy":"LikeCount"}},[_c('SvgIcon',{attrs:{"type":_vm.iconType,"data-cy":"LikeCount__icon","large":!_vm.medium,"medium":_vm.medium}}),_c('span',{staticClass:"u-marginLeft1"},[_vm._v(" "+_vm._s(_vm.count)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }